import React from 'react'

const ImageSlide = ({ url, height, width }) => {
	return (
		<div className={"image-slide"} style={{width, height}} >
			<img src={url} alt="" className={"image-wrapper"}/>
		</div>
	);
}

export default ImageSlide


// WEBPACK FOOTER //
// ./components/common/global-carousel/ImageSlide.js